import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AvisClientsCarousel from '../components/AvisClientsCarousel';
import VehicleCard from '../components/VehicleCard';
import { getVehiclesPublic } from '../services/api';
import { useScrollRestore } from '../hooks/useScrollRestore';

function VehiculesNeufs() {
  const [vehicles, setVehicles] = useState([]);
  const [vendus, setVendus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [showTri, setShowTri] = useState(false);
  const [tri, setTri] = useState('nouveautes');
  const [filters, setFilters] = useState({
    carburant: '', transmission: '', marque: '', modele: '', anneeMin: '', moisMin: '', anneeMax: '', moisMax: '', prixMin: '', prixMax: '', kmMin: '', kmMax: '',
  });
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 30;

  useEffect(() => {
    getVehiclesPublic()
      .then(res => {
        const neufs = res.data.filter(v => v.etat === 'Neuf' && v.statut === 'EN_LIGNE');
        setVehicles(neufs);
        setVendus(res.data.filter(v => v.statut === 'VENDU' && v.etat === 'Neuf').slice(0, 6));
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  useScrollRestore(loading);

  const marques = [...new Set(vehicles.map(v => v.marque).filter(Boolean))].sort();
  const modeles = [...new Set(vehicles.filter(v => !filters.marque || v.marque === filters.marque).map(v => v.modele).filter(Boolean))].sort();

  const handleFilterChange = (e) => { setFilters({ ...filters, [e.target.name]: e.target.value }); setPage(1); };

  const resetFilters = () => {
    setFilters({ carburant: '', transmission: '', marque: '', modele: '', anneeMin: '', moisMin: '', anneeMax: '', moisMax: '', prixMin: '', prixMax: '', kmMin: '', kmMax: '' });
    setSearch('');
    setTri('nouveautes');
  };

  const filtered = vehicles.filter(v => {
    const s = search.toLowerCase();
    const matchSearch = !search || (v.marque && v.marque.toLowerCase().includes(s)) || (v.modele && v.modele.toLowerCase().includes(s));
    const matchCarburant = !filters.carburant || v.carburant === filters.carburant;
    const matchTransmission = !filters.transmission || v.transmission === filters.transmission;
    const matchMarque = !filters.marque || v.marque === filters.marque;
    const matchModele = !filters.modele || v.modele === filters.modele;
    const dateMatch = v.dateMiseEnCirculation ? String(v.dateMiseEnCirculation).match(/(\d{2})\/(\d{2})\/(\d{4})/) : null;
    const dateValeur = dateMatch ? parseInt(dateMatch[3]) * 100 + parseInt(dateMatch[2]) : null;
    const dateMin = filters.anneeMin ? parseInt(filters.anneeMin) * 100 + (filters.moisMin ? parseInt(filters.moisMin) : 1) : null;
    const dateMax = filters.anneeMax ? parseInt(filters.anneeMax) * 100 + (filters.moisMax ? parseInt(filters.moisMax) : 12) : null;
    const matchAnneeMin = !dateMin || (dateValeur !== null && dateValeur >= dateMin);
    const matchAnneeMax = !dateMax || (dateValeur !== null && dateValeur <= dateMax);
    const matchPrixMin = !filters.prixMin || v.prix >= parseInt(filters.prixMin);
    const matchPrixMax = !filters.prixMax || v.prix <= parseInt(filters.prixMax);
    const matchKmMin = !filters.kmMin || v.kilometrage >= parseInt(filters.kmMin);
    const matchKmMax = !filters.kmMax || v.kilometrage <= parseInt(filters.kmMax);
    return matchSearch && matchCarburant && matchTransmission && matchMarque && matchModele && matchAnneeMin && matchAnneeMax && matchPrixMin && matchPrixMax && matchKmMin && matchKmMax;
  });

  const triOptions = [
    { value: 'nouveautes', label: 'Nouveautés' },
    { value: 'prix-asc', label: 'Prix croissant' },
    { value: 'prix-desc', label: 'Prix décroissant' },
    { value: 'promo', label: 'Promo' },
  ];

  const sorted = [...filtered].sort((a, b) => {
    if (tri === 'prix-asc') return (a.prix || 0) - (b.prix || 0);
    if (tri === 'prix-desc') return (b.prix || 0) - (a.prix || 0);
    if (tri === 'promo') return (b.prixPromo ? 1 : 0) - (a.prixPromo ? 1 : 0);
    return (a.position ?? 9999) - (b.position ?? 9999);
  });
  const totalPages = Math.ceil(sorted.length / PAGE_SIZE) || 1;
  const paginated = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const getPageNums = (cur, tot) => {
    if (tot <= 7) return Array.from({ length: tot }, (_, i) => i + 1);
    const p = [1];
    if (cur > 4) p.push('...');
    for (let i = Math.max(2, cur - 1); i <= Math.min(tot - 1, cur + 1); i++) p.push(i);
    if (cur < tot - 3) p.push('...');
    p.push(tot);
    return p;
  };
  const goToPage = (p) => { setPage(p); document.getElementById('vehicules-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };

  return (
    <div className="bg-white min-h-screen">
      <Header />
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-black text-4xl font-bold mb-2">
          Véhicules <span className="text-yellow-500">neufs</span>
        </h1>
        <p className="text-gray-400 mb-8">Découvrez notre sélection de véhicules neufs</p>

        <div className="flex gap-3 mb-4">
          <div className="flex-1 relative">
            <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher par marque, modèle..." className="w-full border-2 border-gray-200 rounded-xl px-5 py-3 focus:outline-none focus:border-yellow-500 transition text-black" />
            {search && <button onClick={() => setSearch('')} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-black">x</button>}
          </div>
          <button onClick={() => setShowFilters(!showFilters)} className={`px-6 py-3 rounded-xl font-bold border-2 transition ${showFilters ? 'bg-yellow-500 text-black border-yellow-500' : 'border-gray-200 text-gray-600 hover:border-yellow-500 hover:text-yellow-600'}`}>
            Filtres
          </button>
          <div className="relative">
            <button onClick={() => setShowTri(!showTri)} className={`px-6 py-3 rounded-xl font-bold border-2 transition flex items-center gap-2 ${showTri ? 'bg-yellow-500 text-black border-yellow-500' : 'border-gray-200 text-gray-600 hover:border-yellow-500 hover:text-yellow-600'}`}>
              Trier <span className="text-xs">{showTri ? '▲' : '▼'}</span>
            </button>
            {showTri && (
              <>
                <div className="fixed inset-0 z-10" onClick={() => setShowTri(false)} />
                <div className="absolute right-0 top-full mt-2 bg-white border border-gray-200 rounded-2xl shadow-xl z-20 min-w-48 overflow-hidden">
                  {triOptions.map(opt => (
                    <button key={opt.value} onClick={() => { setTri(opt.value); setShowTri(false); }}
                      className={`w-full text-left px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition border-b border-gray-100 last:border-0 ${tri === opt.value ? 'font-bold text-black' : 'text-gray-600'}`}>
                      {opt.label}
                      {tri === opt.value && <span className="text-yellow-500 text-lg">✓</span>}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {showFilters && (
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 mb-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Marque</label>
                <select name="marque" value={filters.marque} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                  <option value="">Toutes</option>
                  {marques.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Modèle</label>
                <select name="modele" value={filters.modele} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                  <option value="">Tous</option>
                  {modeles.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Carburant</label>
                <select name="carburant" value={filters.carburant} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                  <option value="">Tous</option>
                  <option value="Essence">Essence</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Electrique">Electrique</option>
                  <option value="Hybride">Hybride</option>
                </select>
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Transmission</label>
                <select name="transmission" value={filters.transmission} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                  <option value="">Toutes</option>
                  <option value="Manuelle">Manuelle</option>
                  <option value="Automatique">Automatique</option>
                </select>
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Mise en circ. depuis</label>
                <div className="flex gap-2">
                  <select name="moisMin" value={filters.moisMin} onChange={handleFilterChange} className="flex-1 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm">
                    <option value="">Mois</option>
                    {['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'].map((m,i) => <option key={i+1} value={String(i+1).padStart(2,'0')}>{m}</option>)}
                  </select>
                  <input type="number" name="anneeMin" value={filters.anneeMin} onChange={handleFilterChange} placeholder="Année" min="1990" max="2030" className="w-24 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm" />
                </div>
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Mise en circ. jusqu'à</label>
                <div className="flex gap-2">
                  <select name="moisMax" value={filters.moisMax} onChange={handleFilterChange} className="flex-1 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm">
                    <option value="">Mois</option>
                    {['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'].map((m,i) => <option key={i+1} value={String(i+1).padStart(2,'0')}>{m}</option>)}
                  </select>
                  <input type="number" name="anneeMax" value={filters.anneeMax} onChange={handleFilterChange} placeholder="Année" min="1990" max="2030" className="w-24 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm" />
                </div>
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Prix min (€)</label>
                <input type="number" name="prixMin" value={filters.prixMin} onChange={handleFilterChange} placeholder="Ex: 10000" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black" />
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Prix max (€)</label>
                <input type="number" name="prixMax" value={filters.prixMax} onChange={handleFilterChange} placeholder="Ex: 50000" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black" />
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Kilométrage min (km)</label>
                <input type="number" name="kmMin" value={filters.kmMin} onChange={handleFilterChange} placeholder="Ex: 0" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black" />
              </div>
              <div>
                <label className="text-gray-600 text-sm font-semibold mb-1 block">Kilométrage max (km)</label>
                <input type="number" name="kmMax" value={filters.kmMax} onChange={handleFilterChange} placeholder="Ex: 100000" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black" />
              </div>
            </div>
            <div className="flex justify-between items-center mt-4">
              <p className="text-gray-500 text-sm">{sorted.length} véhicule(s) trouvé(s)</p>
              <button onClick={resetFilters} className="text-red-400 hover:text-red-600 font-semibold text-sm transition">Réinitialiser</button>
            </div>
          </div>
        )}

        <div id="vehicules-section" />
        {loading ? (
          <div className="text-center text-yellow-500 text-xl py-20">Chargement...</div>
        ) : sorted.length === 0 ? (
          <div className="text-center text-gray-500 py-20">
            <p className="text-2xl mb-2">Aucun véhicule neuf trouvé</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {paginated.map(vehicle => (
                <div key={vehicle.id} id={`vehicle-${vehicle.id}`}>
                  <VehicleCard vehicle={vehicle} />
                </div>
              ))}
            </div>
            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-2 mt-12 flex-wrap">
                <button onClick={() => goToPage(page - 1)} disabled={page === 1} className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 disabled:opacity-30 hover:border-yellow-500 hover:text-yellow-600 transition font-bold">‹</button>
                {getPageNums(page, totalPages).map((p, i) =>
                  p === '...' ? <span key={`e-${i}`} className="w-10 h-10 flex items-center justify-center text-gray-400 text-sm">…</span>
                  : <button key={p} onClick={() => goToPage(p)} className={`w-10 h-10 rounded-full border text-sm font-bold transition ${p === page ? 'bg-yellow-500 border-yellow-500 text-black' : 'border-gray-200 text-gray-600 hover:border-yellow-500 hover:text-yellow-600'}`}>{p}</button>
                )}
                <button onClick={() => goToPage(page + 1)} disabled={page === totalPages} className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 disabled:opacity-30 hover:border-yellow-500 hover:text-yellow-600 transition font-bold">›</button>
              </div>
            )}
          </>
        )}
      </div>
      {vendus.length > 0 && (
        <div className="bg-gray-50 border-t border-gray-100 py-16 px-4 mt-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-8">
              <div>
                <p className="text-yellow-500 text-sm font-bold uppercase tracking-widest mb-1">Déjà partis</p>
                <h2 className="text-black font-extrabold text-3xl">Véhicules neufs <span className="text-yellow-500">vendus</span></h2>
              </div>
              <a href="/vendus" className="text-gray-500 hover:text-yellow-500 font-semibold text-sm transition flex items-center gap-1">Voir tous les vendus <span className="text-lg">→</span></a>
            </div>
            <div className="flex gap-5 overflow-x-auto pb-4" style={{ scrollbarWidth: 'thin', scrollbarColor: '#eab308 #f3f4f6' }}>
              {vendus.map(v => (
                <a key={v.id} href={`/vehicle/${v.id}`} className="flex-shrink-0 w-64 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group block" style={{ height: '200px' }}>
                  <div className="relative h-full overflow-hidden">
                    {v.mainImageUrl ? <img src={v.mainImageUrl} alt={`${v.marque} ${v.modele}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="w-full h-full bg-gray-800 flex items-center justify-center text-5xl">🚗</div>}
                    <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                      <span className="bg-yellow-500 text-black text-sm font-extrabold px-4 py-2 rounded-xl transform -rotate-12 shadow-lg">VENDU</span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                      <h4 className="font-bold text-white text-sm leading-tight">{v.marque} {v.modele}</h4>
                      <p className="text-gray-300 text-xs mt-1">{v.dateMiseEnCirculation}{v.kilometrage ? ` · ${v.kilometrage.toLocaleString()} km` : ''}</p>
                      <p className="text-gray-300 text-xs mt-0.5">{v.carburant}</p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
      <AvisClientsCarousel filterType="neuf" />
      <Footer />
    </div>
  );
}

export default VehiculesNeufs;